import {parsePdfInkAnnotations,type PdfInkAnnotation} from '@reados/contracts';

/** The only format translated to PDF.js's private editor/worker transport. */
export const PDF_INK_PDFJS_VERSION='5.7.284';
export function assertPdfInkVersion(version:string){
 if(version!==PDF_INK_PDFJS_VERSION)throw new Error(`手写批注适配版本不匹配（需要 PDF.js ${PDF_INK_PDFJS_VERSION}）`);
}
export function inkToPdfJs(ink:PdfInkAnnotation){
 const valid=parsePdfInkAnnotations([ink],ink.pageIndex)[0];
 return {annotationType:15,pageIndex:valid.pageIndex,rect:[...valid.rect],rotation:valid.rotation,color:[...valid.color],thickness:valid.thickness,opacity:valid.opacity,
  paths:{lines:valid.paths.lines.map(line=>line.map(n=>n===null?NaN:n)),points:valid.paths.points.map(points=>[...points])},id:null,annotationElementId:null};
}
export function inkFromPdfJs(value:unknown,id:string):PdfInkAnnotation{
 const data=value as {pageIndex:number;rect:number[];rotation:number;color:number[];thickness:number;opacity:number;paths:{lines:ArrayLike<number>[];points:ArrayLike<number>[]}};
 if(!data?.paths)throw new Error('PDF 手写批注没有有效笔迹');
 const ink={id,pageIndex:data.pageIndex,rect:Array.from(data.rect),rotation:data.rotation,color:Array.from(data.color),thickness:data.thickness,opacity:data.opacity,
  paths:{lines:data.paths.lines.map(line=>Array.from(line,n=>Number.isNaN(n)?null:n)),points:data.paths.points.map(points=>Array.from(points))}};
 return parsePdfInkAnnotations([ink],data.pageIndex)[0];
}
export function inkFingerprint(annotations:PdfInkAnnotation[]){return JSON.stringify([...annotations].sort((a,b)=>a.id.localeCompare(b.id)));}
